import React, {useState} from 'react';
import {TextContent} from "./TextContent";

export function ExamQuestion({question, setTestAnswers, index}) {

    const[selected, setSelected] = useState([]);

    const checkboxStyle = {
        width:"1.5vw",
        height:"1.5vw"
    }


    function selectOption(option) {
        let copy = [...selected]
        if(copy.includes(option)) {
            copy.splice(copy.indexOf(option), 1)
        } else {
            if(selected.length > 0) {
                if(question.multipleChoice) {
                    copy.push(option)
                } else {
                    copy = [option]
                }
            } else {
                copy = [option]
            }

        }
        setSelected(copy)
        setTestAnswers(index, copy)
    }

    if (question != null && question.options != null) {
        return (
            <div className={"row my-2"}>


                <div className={"col"}>

                    <TextContent level={4} value={question.text}/>

                    {
                        question.options.map(option => (

                            <div className={"ps-3"}>
                                <div className={"row mb-2"}>

                                    <div className={"col-1"}>
                                        <input checked={selected.includes(option)} type={"checkbox"}
                                               className={"form-check-input p-0 m-0"} style={checkboxStyle}
                                               onChange={() => selectOption(option)}/>
                                    </div>
                                    <div className={"col"}>
                                        <TextContent level={0} value={option.text}/>
                                    </div>

                                </div>
                            </div>

                        ))
                    }
                    {
                        question.multipleChoice ?
                            <p className={"text-muted m-0"}>Kan ha flere riktige svar</p> : null
                    }
                </div>

                {
                    question.questionType === "IMAGE_QUESTION" ?

                        (
                            <div className={"col d-flex justify-content-center align-items-center"}>
                                <img src={question.image.url} className={"rounded p-0 m-0  w-100"}/>
                            </div>
                        ) : null
                }


            </div>
        );
    }
}